import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { isImageConfigurableForShapeImageFill } from '@src/slide/domain/ui-model/element-modeles/property/fill/image-fill/is-image-configurable';
import { getAllImage } from '@src/slide/application/service/menu-manager/menu-values/element-menu-values-getter';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import BaseToolbarFeature from './base-toolbar-feature';

const NO_IMAGE = 0;
export class BaseImageFeature extends BaseToolbarFeature {
    public shouldTalorHide() {
        const model = this.getSelectionService().getSelectedModel();
        if (model) {
            const { type } = model;
            if (isImageConfigurableForShapeImageFill(model)) {
                return false;
            }
            if (getAllImage(model as IElementBaseModel | IMultiplyModel)?.length > NO_IMAGE) {
                return false;
            }
            return type !== UIModelType.IMAGE;
        }
        return true;
    }
}
